import React from "react";
import { VoiceRunLogo } from "./base";
import { ReactComponent as PrimVoicesLogo } from "../assets/svg/logo.svg";

interface ProviderLogoProps {
  provider: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const ProviderLogo: React.FC<ProviderLogoProps> = ({ provider, size = "sm", className = "" }) => {
  const getImagePath = (providerName: string): string => {
    const providerMap: Record<string, string> = {
      openai: "/images/model_images/openai_dark.webp",
      azure: "/images/model_images/azure_logo.svg",
      google: "/images/model_images/google_logo.webp",
      cartesia: "/images/model_images/cartesia_dark.webp",
      prim: "/images/logos/logo.png",
      minimax: "/images/model_images/minimax_logo.webp",
    };

    return providerMap[provider.toLowerCase()] || "/images/logos/logo.png";
  };

  const isVoiceRun = typeof window !== "undefined" && window.location.hostname.includes("voicerun");
  const isPrimProvider = provider.toLowerCase() === "prim";

  const getSizeClasses = (size: string): string => {
    const sizeMap: Record<string, string> = {
      sm: "h-4 w-auto",
      md: "h-6 w-auto",
      lg: "h-8 w-auto",
    };

    return sizeMap[size] || sizeMap["sm"];
  };

  // If it's prim provider, use brand-specific logo component
  if (isPrimProvider) {
    if (isVoiceRun) {
      return <VoiceRunLogo className={`${getSizeClasses(size)} ${className}`} />;
    } else {
      return <PrimVoicesLogo className={`${getSizeClasses(size)} ${className}`} />;
    }
  }

  // Otherwise use regular image
  const getImageStyles = () => {
    if (provider.toLowerCase() === "openai") {
      return "brightness-75"; // Make OpenAI darker in light mode
    }
    if (provider.toLowerCase() === "minimax") {
      return "dark:brightness-0 dark:invert"; // Make white in dark mode
    }
    return "";
  };

  return (
    <img
      src={getImagePath(provider)}
      alt={`${provider} logo`}
      className={`${getSizeClasses(size)} object-contain ${getImageStyles()} ${className}`}
      loading="lazy"
      decoding="async"
    />
  );
};
